// extracted by mini-css-extract-plugin
export default {"list":"nav-list_list__PgG45","list_element":"nav-list_list_element__ZR5x8","text":"nav-list_text__jNobH"};